/**
 * Navigation state for opening the Cinema search from outside the search page (header search,
 * topic links). Each such navigation gets a new id, so the search page starts from the address;
 * the page's own filter changes keep the id and therefore keep focus and in-progress state.
 */
let counter = 0;

export interface SearchNavigationState {
  search: number;
}

/** Call in event handlers only (not during render). */
export function freshSearchState(): SearchNavigationState {
  counter += 1;
  return { search: counter };
}

export function searchStateId(state: unknown): number {
  return typeof state === 'object' && state !== null && 'search' in state
    ? Number((state as SearchNavigationState).search) || 0
    : 0;
}
